<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="70%">
      <v-card>
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-toolbar dark color="deep-purple">
          <v-icon medium>{{ title.icon }}</v-icon>
          <v-toolbar-title>{{ title.text }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="close" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 md12>
                <v-text-field label="รหัสกลุ่ม" v-model="item.code" :rules="[rules.required]" required></v-text-field>
              </v-flex>
              <v-flex xs12 md12>
                <v-text-field label="ชื่อกลุ่ม" v-model="item.name" :rules="[rules.required]" required></v-text-field>
              </v-flex>
              <v-flex xs12 md12>
                <v-select
                  :items="dayItems"
                  v-model="item.day"
                  label="วันที่สอน"
                  :rules="[rules.required]"
                  required
                ></v-select>
              </v-flex>
              <v-flex xs6 md4>
                <v-menu
                  ref="menuStartTime"
                  :close-on-content-click="false"
                  v-model="menuStartTime"
                  :nudge-right="40"
                  :return-value.sync="item.startTime"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="item.startTime"
                    label="เวลาเริ่มต้น"
                    prepend-icon="access_time"
                    readonly
                  ></v-text-field>
                  <v-time-picker v-model="item.startTime" format="24hr" @change="$refs.menuStartTime.save(item.startTime)"></v-time-picker>
                </v-menu>
              </v-flex>
              <v-flex xs6 md4>
                <v-menu
                  ref="menuEndTime"
                  :close-on-content-click="false"
                  v-model="menuEndTime"
                  :nudge-right="40"
                  :return-value.sync="item.endTime"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="item.endTime"
                    label="เวลาสิ้นสุด"
                    prepend-icon="access_time"
                    readonly
                  ></v-text-field>
                  <v-time-picker v-model="item.endTime" format="24hr" @change="$refs.menuEndTime.save(item.endTime)"></v-time-picker>
                </v-menu>
              </v-flex>
              <v-flex xs6 md4>
                <v-text-field label="จำนวนชั่วโมง" v-model="item.hours" disabled></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete
                  :items="roomItems"
                  v-model="item.room"
                  label="ห้องเรียน"
                  item-value="id"
                  item-text="label"
                  return-object
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 md12>
                <v-autocomplete
                  :items="personItems"
                  v-model="item.instructors"
                  label="อาจารย์ที่ปรึกษากลุ่ม"
                  item-value="id"
                  item-text="fullname"
                  return-object
                  multiple
                  chips
                  :rules="[v => !!v || 'Item is required']" 
                  required
                ></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="grey white--text" :loading="loading" :disabled="loading" @click.native="close">ยกเลิก</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" :loading="loading" :disabled="loading" @click.native="onSubmit">บันทึก</v-btn>
        </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import swal from 'sweetalert2'

export default {
  props: ['activeCourseId', 'dialog', 'item', 'title'],
  data () {
    return {
      dayItems: [ 'วันจันทร์', 'วันอังคาร', 'วันพุธ', 'วันพฤหัสบดี', 'วันศุกร์', 'วันเสาร์', 'วันอาทิตย์'],
      loading: false,
      valid: false,
      rules: {
        required: (value) => !!value || 'ไม่สามารถเป็นค่าว่าง'
      },
      menuStartTime: false,
      startTime: null,
      menuEndTime: false,
      endTime: null
    }
  },
  computed: {
    ...mapGetters({
      personItems: 'person/personItems',
      roomItems: 'roomItems'
    })
  },
  mounted () {

  },
  methods: {
    clear () {
      
    },
    close: function() {
      this.$emit('dialog', false)
    },
    onSubmit () {
      if (this.$refs.form.validate()) {
        this.loading = true
        let dispatch = this.item.id && this.item.id > 0 ? 'section/update' : 'section/create'
        this.$store.dispatch(dispatch, this.item)
          .then((response) => {
            // console.log('onSave:', response )
            this.loading = false
            swal({
              title: 'Success!',
              type: 'success'
            }).then(response => {
              this.close()
            })
          }).catch((error) => {
            this.loading = false
            swal('Error!', error.message, 'error')
          })
      }
    }
  },
  watch: {
    'item.startTime' (val) {
      if(this.item.endTime) {
        if( moment( val, "kk:mm" ) >= moment( this.item.endTime, "kk:mm" ) ) {
          this.$store.dispatch('storeAlertOnFail', 'เวลาเริ่มต้นไม่ควรมากกว่าเวลาสิ้นสุด')  
        } else {
          this.item.hours = moment.duration( moment( this.item.endTime, "kk:mm" ) - moment( this.item.startTime, "kk:mm" ) ).asHours()
        }
      }
    },
    'item.endTime' (val) {
      if(this.item.startTime) {
        if( moment( val, "kk:mm" ) <= moment( this.item.startTime, "kk:mm" ) ) {
          this.$store.dispatch('storeAlertOnFail', 'เวลาสิ้นสุดไม่ควรน้อยกว่าเวลาเริ่มต้น')  
        } else {
          this.item.hours = moment.duration( moment( this.item.endTime, "kk:mm" ) - moment( this.item.startTime, "kk:mm" ) ).asHours()
        }
      }
    }
  }
}

</script>


// WEBPACK FOOTER //
// src/components/management/course/section/formDialog.vue